var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(-995 -16)"},React.createElement("g",null,[React.createElement("path",{"fill":"currentColor","d":"M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z","transform":"translate(995 16)","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","transform":"translate(995 16)","key":1})])));
}

Delete.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Delete;

Delete.default = Delete;
